export default "__VITE_ASSET__BReXpXtR__"